import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, FormControl, Select, MenuItem, InputLabel, Tooltip } from '@material-ui/core';
import moment from 'moment'
import styles from './styles'
import { ChevronLeftOutlined, ChevronRightOutlined } from '@material-ui/icons';
import { slots as baseSlots } from '../utils/defaultSlots';
import { useMediaQuery } from 'react-responsive';
import AppointmentServices from '../services/appointmentServices';

export default function Calendar(props) {

    const useStyles = makeStyles(styles);
    const classes = useStyles();

    const [slots, setSlots] = useState([...baseSlots])
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const isMobileForIframe = useMediaQuery({ maxWidth: 720 });

    const [selectedDate, setSelectedDate] = useState(moment())
    const [displayslots, setDisplaySlots] = useState()
    const [hiddenSlots, setHiddenSlots] = useState({})

    const [showMoreMap, setShowMoreMap] = useState({})
    const [showLessMap, setShowLessMap] = useState({})
    const [filteredList, setFilteredList] = useState()

    const [meetingLocation, setMeetingLocation] = useState('select_location')
    const [locationList, setLocationList] = useState([])

    const isMobileScreen = () => {
        if (props.isIframe)
            return isMobileForIframe
        return isMobile
    }

    const handleChangeLocation = (event) => {
        setMeetingLocation(event.target.value)
    }

    const updateWeekList = () => {
        setHiddenSlots({})
        const tempSlot = {}
        let date = moment(selectedDate).format("YYYY-MM-DD")
        const daysCapacity = isMobileScreen() ? 2 : 5
        for (let i = 1; i <= daysCapacity; i++) {
            const weekday = moment(date, "YYYY-MM-DD").isoWeekday()
            tempSlot[date] = [{
                slotName: "dummy_slot",
                isBooked: false,
                isUnavailable: true,
                displayTime: "03:30 pm"
            }]
            date = moment(date, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD")
        }
        setFilteredList({ ...tempSlot })
        return tempSlot
    }

    useEffect(() => {
        if (displayslots) {
            const tempObjDisplaySlots = { ...displayslots }
            const filteredSlots = {}
            const showMoreSlots = {}
            const daysCapacity = 5
            Object.keys(tempObjDisplaySlots).forEach(key => {
                const tempDateSlotArr = tempObjDisplaySlots[key]
                if (tempDateSlotArr.length <= daysCapacity)
                    filteredSlots[key] = tempDateSlotArr
                else {
                    filteredSlots[key] = tempDateSlotArr.slice(0, daysCapacity - 1)
                    showMoreSlots[key] = tempDateSlotArr.slice(daysCapacity - 1)
                }
            })
            setFilteredList({ ...filteredSlots })
            setShowMoreMap({ ...showMoreSlots })
        }
    }, [displayslots])

    const isShowLess = (date) => {
        if (date in showLessMap && showLessMap[date].length > 0)
            return true
        return false
    }

    const handleShowMore = (date) => {
        const tempShowMore = { ...showMoreMap }
        const tempShowLess = { ...showLessMap }
        const tempfiltered = { ...filteredList }

        let moreArr = [...tempShowMore[date]]
        let lessArr = tempShowLess[date] ? [...tempShowLess[date]] : []
        let currArr = [...tempfiltered[date]]

        if (lessArr.length === 0) {
            const poppedElemFisrt = currArr.shift()
            lessArr.push(poppedElemFisrt)
            const poppedElemSecond = currArr.shift()
            lessArr.push(poppedElemSecond)
        }
        else {
            const poppedElem = currArr.shift()
            lessArr.push(poppedElem)
        }
        const poppedElem2 = moreArr.shift()
        currArr.push(poppedElem2)

        if (moreArr.length == 0) {
            const poppedFromPrev = lessArr.pop()
            currArr.unshift(poppedFromPrev)
        }

        tempShowMore[date] = [...moreArr]
        tempShowLess[date] = [...lessArr]
        tempfiltered[date] = [...currArr]

        setFilteredList({ ...tempfiltered })
        setShowLessMap({ ...tempShowLess })
        setShowMoreMap({ ...tempShowMore })
    }

    const handleShowLess = (date) => {
        const tempShowMore = { ...showMoreMap }
        const tempShowLess = { ...showLessMap }
        const tempfiltered = { ...filteredList }

        let moreArr = tempShowLess[date] ? [...tempShowMore[date]] : []
        let lessArr = [...tempShowLess[date]]
        let currArr = [...tempfiltered[date]]

        const poppedElem = lessArr.pop()
        currArr.unshift(poppedElem)
        if (moreArr.length === 0) {
            const poppedElem = currArr.pop()
            moreArr.unshift(poppedElem)
            const poppedElem2 = currArr.pop()
            moreArr.unshift(poppedElem2)
        }
        else {
            const poppedElem2 = currArr.pop()
            moreArr.unshift(poppedElem2)
        }

        if (lessArr.length == 0) {
            const poppedFromNext = moreArr.shift()
            currArr.push(poppedFromNext)
        }

        tempShowMore[date] = [...moreArr]
        tempShowLess[date] = [...lessArr]
        tempfiltered[date] = [...currArr]
        setFilteredList({ ...tempfiltered })
        setShowLessMap({ ...tempShowLess })
        setShowMoreMap({ ...tempShowMore })
    }

    const isShowMore = (date) => {
        if (date in showMoreMap && showMoreMap[date].length > 0)
            return true
        return false
    }

    const updateSlots = (availableSlots, displaySlotsSet) => {
        setMeetingLocation('select_location')
        props.setSelectedSlot()
        let tempDisplayslots = { ...displaySlotsSet }
        const tempObj = {}
        let locationSet = new Set();
        const currentDateTime = moment.utc()
        availableSlots.forEach(item => {
            const slotDateTime = moment.utc(item.date + " " + item.end_time, "YYYY-MM-DD HH:mm:ss")
            if (moment(slotDateTime).isBefore(currentDateTime))
                return null
            if (item.location != null) {
                if (props.meetingType === 'online') {
                    if (item.location.toLowerCase() === 'online') {
                        locationSet.add(item.location)
                    }
                }
                else {
                    if (item.location.toLowerCase() !== 'online') {
                        locationSet.add(item.location)
                    }
                }
            }
            if (item.date in tempObj) {
                tempObj[item.date] = [
                    ...tempObj[item.date],
                    {
                        slotName: item.start_time,
                        isUnavailable: item.status === "AVAILABLE" ? false : true,
                        isBooked: item.status === "BOOKED" ? true : false,
                        displayTime: moment.utc(item.date + " " + item.start_time).local().format("h:mm a"),
                        ...item
                    }
                ]
            }
            else {
                tempObj[item.date] = [{
                    slotName: item.start_time,
                    isUnavailable: item.status === "AVAILABLE" ? false : true,
                    isBooked: item.status === "BOOKED" ? true : false,
                    displayTime: moment.utc(item.date + " " + item.start_time).local().format("h:mm a"),
                    ...item
                }]
            }
        })
        setLocationList(Array.from(locationSet))
        tempDisplayslots = { ...tempDisplayslots, ...tempObj }
        setDisplaySlots({ ...tempDisplayslots })
    }

    const isSlotSelected = (date, time) => {
        if (props.selectedSlot && props.selectedSlot.slotId === time.id)
            return true
        return false
    }

    const handleSlotSelect = (selectedDate, selectedTime) => {
        props.setSelectedSlot({
            date: selectedDate,
            time: selectedTime.slotName,
            slotId: selectedTime.id,
            start_time: selectedTime.start_time,
            end_time: selectedTime.end_time,
            location_id: selectedTime.location_id
        })
    }

    useEffect(() => {
        if (props.accountId) {
            const dateCapacity = isMobileScreen() ? 2 : 5
            props.setIsLoading(true)
            setFilteredList()
            setShowMoreMap({})
            setShowLessMap({})
            const startDate = moment(selectedDate).format("YYYY-MM-DD")
            const endDate = moment(startDate, "YYYY-MM-DD").add(dateCapacity - 1, 'days').format("YYYY-MM-DD")
            const accID = props.accountId
            const tempSlotsSet = updateWeekList()
            AppointmentServices
                .getAvailableSlots(accID, startDate, endDate)
                .then(res => {
                    updateSlots(res.data, tempSlotsSet)
                })
                .catch(err => {
                    console.log(err)
                    updateSlots([], tempSlotsSet)
                })
                .finally(fin => {
                    props.setIsLoading(false)
                })
        }
        else {
            const tempSlotsSet = updateWeekList()
            updateSlots([], tempSlotsSet)
        }
    }, [selectedDate, props.accountId, props.meetingType, isMobile, isMobileForIframe, props.isIframe])

    useEffect(() => {
        if (locationList && locationList.length > 0) {
            setMeetingLocation(locationList[0])
        }
    }, [locationList])

    const handleWeekChange = (mode) => {
        const dateCapacity = isMobileScreen() ? 2 : 5
        switch (mode) {
            case 'prev':
                const selectedDateFormatted = moment(selectedDate).format("YYYY-MM-DD")
                const todaysDateFormatted = moment().format("YYYY-MM-DD")
                if (selectedDateFormatted === todaysDateFormatted)
                    break;
                const newDatePrev = moment(selectedDate).subtract(dateCapacity, 'd')
                setSelectedDate(newDatePrev)
                break;
            case 'next':
                const newDateNext = moment(selectedDate).add(dateCapacity, 'd')
                setSelectedDate(newDateNext)
                break;
        }
    }

    return (
        <Box flex={1}>
            <Box marginBottom="25px">
                <FormControl variant="outlined" fullWidth>
                    {/* <Typography className={classes.subTitleFont}>Chose your location</Typography> */}
                    <InputLabel id="demo-simple-select-outlined-label">Location</InputLabel>
                    <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={meetingLocation}
                        inputProps={props.isMiniScreen ? { autoWidth: true } : {}}
                        onChange={handleChangeLocation}
                        label="location"
                    >
                        <MenuItem disabled value={'select_location'}>
                            Select Location
                        </MenuItem>
                        {
                            locationList && locationList.length > 0
                                ?
                                locationList.map(item =>
                                    <MenuItem value={item}>
                                        {item}
                                    </MenuItem>
                                )
                                :
                                ''
                        }
                    </Select>
                </FormControl>
            </Box>
            <Box className={classes.calendarRoot}>
                <Box className={classes.arrowBox}>
                    <ChevronLeftOutlined className={classes.arrowIcon} onClick={() => { handleWeekChange('prev') }} />
                </Box>
                {
                    filteredList ?
                        <Box className={classes.calendarCentralRootBox}>
                            {
                                Object.keys(filteredList).map((item, index) =>
                                    <Box key={"dayBoxNo_" + index} className={classes.dayBox}>
                                        <Box className={classes.dayAndDateBox} alignItems="center" marginBottom="10px">
                                            <Typography className={classes.dayText}>{moment(item, "YYYY-MM-DD").format("ddd")}</Typography>
                                            <Typography className={classes.dayText}>{moment(item, "YYYY-MM-DD").format("MMM DD")}</Typography>
                                        </Box>
                                        <Box>
                                            {
                                                isShowLess(item)
                                                    ?
                                                    <Box className={classes.moreBox} onClick={() => handleShowLess(item)}>
                                                        <Typography className={classes.dayText}>less</Typography>
                                                    </Box>
                                                    :
                                                    ''
                                            }
                                            {
                                                props.unavailableDates.includes(item)
                                                    ?
                                                    <Box
                                                        key={"slotBoxNO_NOTAVAIL" + item + "_"}
                                                        className={classes.bookedSlotBox}
                                                    >
                                                        <Typography className={classes.dayText}>{"-"}</Typography>
                                                    </Box>
                                                    :
                                                    filteredList[item].map((x, i) =>
                                                        x.slotName !== "dummy_slot" && meetingLocation !== "uncategorised" && meetingLocation !== x.location
                                                            ?
                                                            <Tooltip title="Slot not available in selected location">
                                                                <Box
                                                                    key={"slotBoxNO_" + index + "_" + i}
                                                                    className={classes.bookedSlotBoxWithPointerEvent}
                                                                // onClick={() => handleSlotSelect(item, x)}
                                                                >

                                                                    <Typography className={classes.dayTextBlurred}>{x.displayTime}</Typography>

                                                                </Box>
                                                            </Tooltip>
                                                            :
                                                            <Box
                                                                key={"slotBoxNO_" + index + "_" + i}
                                                                className={x.isUnavailable ? classes.bookedSlotBox : (isSlotSelected(item, x) ? classes.selectedSlotBox : classes.slotBox)}
                                                                onClick={() => handleSlotSelect(item, x)}
                                                            >
                                                                <Typography className={classes.dayText}>{x.isUnavailable ? (x.isBooked ? "Booked" : "-") : x.displayTime}</Typography>
                                                            </Box>
                                                    )
                                            }
                                            {
                                                props.unavailableDates.includes(item)
                                                    ?
                                                    ''
                                                    :
                                                    (
                                                        isShowMore(item)
                                                            ?
                                                            <Box className={classes.moreBox} onClick={() => handleShowMore(item)}>
                                                                <Typography className={classes.dayText}>more</Typography>
                                                            </Box>
                                                            :
                                                            ''
                                                    )
                                            }
                                        </Box>
                                    </Box>
                                )
                            }
                        </Box>
                        :
                        ''
                }
                <Box className={classes.arrowBox}>
                    <ChevronRightOutlined className={classes.arrowIcon} onClick={() => { handleWeekChange('next') }} />
                </Box>
            </Box>
        </Box>
    )
}
